import type { Provider } from '@angular/core';
import { SVG_ICON_CONFIG, SVG_ICON_DOMAIN_NUMBER_STR, type SvgIconConfig } from './token';

export function provideSvgIcon(config: SvgIconConfig, domainNumberStr: string = ''): Provider[] {
  return [
    { provide: SVG_ICON_CONFIG, useValue: config },
    { provide: SVG_ICON_DOMAIN_NUMBER_STR, useValue: domainNumberStr }
  ];
}
